import { render, staticRenderFns } from "./artefact-results.vue?vue&type=template&id=647389fb&scoped=true&"
import script from "./artefact-results.vue?vue&type=script&lang=ts&"
export * from "./artefact-results.vue?vue&type=script&lang=ts&"
import style0 from "./artefact-results.vue?vue&type=style&index=0&id=647389fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647389fb",
  null
  
)

export default component.exports